module.exports = __webpack_public_path__ + "img/logo.93d4e22c.png";